// İSG Portal — Skeleton (S33 planı Stage 2, yeni): yükleniyor çubuğu — "no shimmer radius"
// (README Stage 2): düz gri çubuk, animasyon/parlama YOK, köşe YOK. Kabul kriteri (plan
// "Acceptance checklist"): "Loading = skeleton rows; empty = title + one ghost action" —
// yani her tablonun yükleniyor durumu ORTALANMIŞ bir `Spinner` DEĞİL, `TableSkeletonRows`.
// Henüz hiçbir sayfa tüketmiyor (ilk gerçek tüketici Slice 3/4'ün tabloları).

import { TableCell, TableRow } from './Table';
import { cn } from './cn';

/** Tek bir gri çubuk — kart/satır İÇİNDE serbestçe boyutlandırılır (`className` ile genişlik/
 * yükseklik). Varsayılan `h-2` (README) + tam genişlik. */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('h-2 w-full bg-surface-muted', className)} aria-hidden="true" />;
}

/** Bir `Table`'ın yükleniyor durumu — 4 hayalet satır (README kabul kriteri), her hücrede
 * tek bir `Skeleton` çubuğu. `colSpan` yerine gerçek hücre SAYISI (`columns`) verilir —
 * bu satırlar gerçek `TableRow`/`TableCell` (ekran okuyucu `TableMessageRow`'un tek-hücreli
 * anonsundan FARKLI, ama bir yükleniyor durumu zaten `aria-busy`/canlı bölge ile ayrı
 * duyurulmalı — çağıran taraf `Table`'ı `aria-busy` ile sarmalar). */
export function TableSkeletonRows({
  rows = 4,
  columns,
}: {
  rows?: number;
  columns: number;
}) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: sabit sayıda dekoratif hayalet satır, hiç yeniden sıralanmaz.
        <TableRow key={rowIndex}>
          {Array.from({ length: columns }).map((__, colIndex) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: sabit sütun sayısı, aynı gerekçe.
            <TableCell key={colIndex}>
              <Skeleton className="max-w-[12rem]" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
